import store from '../store/Store';
import CardDataStore from '../store/CardDataStore';
import { show, hide } from '../libs/Utils';
import { StateType } from '../interface/CommonTypes';

export default class Loading {
    
    private loader: HTMLElement | null = document.querySelector('.history-list-loading');
    private showHideFn: {[keyName: string]: (...el: HTMLElement[])=>void;};

    constructor(){
        store.CardDataStore.LoadEvents.on((_src: CardDataStore, _state: StateType)=> this.update(_state) );
        this.showHideFn = {
            [CardDataStore.LOAD_PENDING]: show,
            [CardDataStore.LOAD_DONE]: hide,
            [CardDataStore.LOAD_ERROR]: show,
        }
    }

    update(_state: StateType){
        if (this.loader instanceof HTMLEmbedElement) {
            this.showHideFn[_state](this.loader);
        }
    }

} // end of class
